import React, { useState } from 'react';
import { Dropdown, MenuProps, Modal } from 'antd';
import { useStore } from '@/app/providers/StoreProvider';
import { useNavigate } from 'react-router';
import ImgOptions from '@/shared/pictures/options.svg';
import ImgClose from '@/shared/pictures/close.svg';


export const TeamLeaderOptions= () => {
  const navigate = useNavigate();
  const {teamStore} = useStore();
  const {deleteTeam} = teamStore;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleDelete = () => {
    deleteTeam();
    setIsModalOpen(false);
    navigate('/menu/teams');
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div className='team-options_default' onClick={()=>navigate('/team-edit')}>
          Редактировать
        </div>
      ),
      key: '0',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <div className='team-options_default team-options_red' onClick={()=>(setIsModalOpen(true))}>
          Удалить команду
        </div>
      ),
      key: '1',
    }
  ];
  return (
    <>
    <Dropdown menu={{items}} trigger={['click']}>
      <img className='team-options' src={ImgOptions} alt="options" />
    </Dropdown>

    <Modal
      title = {null}
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={isModalOpen}
      footer={null}
      closeIcon={<img src={ImgClose} onClick={()=>handleCancel()}/>}
      >
      <div className='modal'>
        <div className='modal_body'>
          <h3 className='modal_title'>Удалить команду?</h3>
        </div>
        <div className='modal_buttons'>
          <button type='button' className='modal_button button_red' onClick={handleDelete}>Удалить</button>
          <button type='button' className='modal_button button_gray' onClick={handleCancel}>Отменить</button>
        </div>
      </div>
      </Modal>
    </>
  );
};
